<template>
    <div>
        <header-nav :cur="2" />
        <div class="nav">
            <div class="navtab">
                <span class="top">
                     <span @click="toIndex()" style="cursor:pointer"  >首页</span>&nbsp;>
                    <span class="infor">课程</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">课程学习中心</div>
                        <div class="newbot">汇集知识碎片，解决学习难题</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text"   v-model="queryParams.courseName"/>
                        <div class="select" @click="getList()">搜索</div>
                    </div>
                </div>
            </div>
        </div>
		<div class="navtab" style="cursor:pointer" >
			<div class="type bacground">
			     <div class="ul">课程分类：&nbsp;</div>
			     <ul style="cursor: pointer;">
			         <li v-for="(item, index) in course_sort_list " :key="index" :class="{ color: index === course_sort_int }" @click="changeLearingType(item.learningType,index)">{{ item.name }}</li>
			     </ul>
			 </div>
		    <div class="type bacground" :style="zyk_display">
		        <div class="ul">专业分类：&nbsp;</div>
		        <ul style="cursor: pointer;">
		            <li v-for="(item, index) in xklx_list" :key="index" :class="{ color: index === int }" @click="actli(item.subjectId,index)">{{ item.subjectName }}</li>
		        </ul>
		    </div>
		</div>
        <!-- 推荐课程 -->
        <div class="navtab" >
            <div class="courselist" style="justify-content: space-between">
                <div class="courbox" v-for="(item, index) in courses" :key="index" @click="todetail(item.id)" style="cursor:pointer" >
                    <div class="play">
						{{ item.credit }}学时
                    </div>
                    <div class="hour">{{ item.lessionNum }}章节</div>
                    <!-- <img src="../../assets/img/index/course.jpg" alt="" /> -->
					<img :src="$api.static_url+item.courseImage" :alt="item.courseName" width="221px" height="136px"/> 
                    <div class="tit" style="margin-bottom: 0.16296rem">{{ item.courseName |shortName }}</div>
                </div>
            </div>
        </div>
		<v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum' @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>
		<footer-nav style="padding-top: 80px;"/>
    </div>
</template>
<script>
import {queryClazzReportState} from '@/api/user.js'
import {queryCourseList,queryCourseById,queryFavoriteCourseList} from '@/api/course.js'	
import pagination from '@/components/common/pagination'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import { Loading } from 'element-ui';

export default {
    components: {
        'v-pagination': pagination,
        'header-nav':headerNav,
        'footer-nav':footerNav,
    },
    data() {
        return {
			queryParams: {
			  pageNum: 1,
			  pageSize: 15,
			  learningType:null,
			  courseName:null,
			  parentSubjectId:null,
			  subjectId:null,
			},
            int: 0,
			sub_subject_int:0,
			course_sort_int:0,
			xxlx_int:0,
			course_sort_list:[
				{
					'learningType':null,
					'name': '全部'
				},
				{
					'learningType':'1',
					'name': '公需课'
				},
				{
					'learningType':'2',
					'name': '专业课'
				}
			],
			zyk_display:'display:none',
            courses: [],
			parentSubjectId:0,
			subSubjectId:0,
			learningTypeId:0,
			xklx_list:[
				{subjectId:null,subjectName:'全部课程'},
				{subjectId:'1',subjectName:'新闻传播'},
				{subjectId:'2',subjectName:'文化旅游'},
				{subjectId:'3',subjectName:'传媒艺术'},
				{subjectId:'4',subjectName:'非遗传承'},
				{subjectId:'5',subjectName:'电子电工'},
				{subjectId:'6',subjectName:'化学化工'},
				{subjectId:'7',subjectName:'经济学科'},
				{subjectId:'8',subjectName:'其他'}
			],
			ejxk_list:null,
			pageCondition:{
				'pageNum':0,
				'pageSize':15
			},
			total:1,
			loading:null
        };
    },
	created() {
		
		var learntype = this.$route.query.learningType;
		if(learntype != null && learntype != ''){	
			if(learntype == '2'){
				this.zyk_display ='';
			}
			this.course_sort_int = parseInt(learntype);
			this.queryParams.learningType = learntype;
		}
		var subid = this.$route.query.subjectId;
		if(subid != null && subid != ''){
			this.int = parseInt(subid);
			this.queryParams.subjectId = subid;
		}
		//this.queryParentSubjectList();
		this.getList();
	},
	filters:{
		shortName(name){
			if(name.length >14 ){
				return name.substring(0,14)+'...';
			}
			return name;
		}
	},
    methods: {
		loadingShow() {
		  this.loading = this.$loading({
		    text: "Loading",  // 显示文本
		    spinner: "el-icon-loading", // 显示的 icon
		    background: "rgba(0, 0, 0, 0.7)", // loading 遮罩层颜色
		    target: document.querySelector("body"), // 挂载的 DOM 元素
		  });
		},
		toIndex(){
			this.$router.push('/');
		},
		pagechange(currentPage){
			console.log(currentPage);
		    this.queryParams.pageNum=currentPage;
		    // ajax请求, 向后台发送 currentPage, 来获取对应的数据
		    this.getList();
		},
		getList(){    
			this.isloading = this.loadingShow();
			queryCourseList(this.queryParams).then(res => {
				var list = res.rows;
				this.courses = [];
				this.courses = res.rows;	
				this.total = res.total;
				this.loading.close();
			})
		},

		changeLearingType(id,int){
			this.queryParams.subjectId = null;
			this.int = 0;
			this.queryParams.learningType = id;
			this.course_sort_int = int;
			if(int == 2){
				this.zyk_display = '';
			}else{
				this.zyk_display = 'display:none';
			}
			this.getList();
		},
        actli(id,int) {
            this.int = int;
			this.sub_subject_int = 100;
			this.queryParams.subjectId = id;
			this.getList();
        },
        todetail(id) {	
			var me = this;
			var data = {
				id:id,
				year:localStorage.getItem('year')
			}
			queryClazzReportState(data).then(res => {
				if(res.code == 200){
					if(res.state == '1'){
						this.$router.push({path:'/course/detail',query:{id:id}});
						return;
					}else{
						//进入试学
						me.$confirm('本课程您未报名，但您可以试看2分钟课程，也可直接前往个人中心报名学习!', '课程试学提示', {
						         distinguishCancelAndClose: true,
															  type:'warning ' ,
						         confirmButtonText: '试学',
						         cancelButtonText: '放弃'
						}).then(() => {
							//跳转到试学
							me.$router.push({
								path: '/course/tryPlay',
								query: {
									courseId: id
								}
							});
						       //alert("试学！");
						}).catch(action => {
						    console.log("取消所属")
						});
												    
						
						
						//this.$message.error(res.msg);
						//return;
					}
				}
			})
			
			
        },
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 177px;
        .top {
            display: block;
            font-size: 16px;
    
            font-weight: 300;
            color: #777777;
            padding: 19px 0 24px;
            .infor {
                color: #2961EF;
            }
        }
        .newbox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .newtop {
                font-size: 26px;
                color: #000000;
                margin-bottom: 5px;
            }
            .newbot {
                font-size: 16px;
                color: #888888;
            }
            .input {
                width: 497px;
                height: 59px;
                background: #ffffff;
                box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                border-radius: 30px;
                position: relative;
                input {
                    border: none;
                    position: absolute;
                    left: 30px;
                    top: 0;
                    height: 59px;
                    line-height: 59px;
                    width: 365px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #777777;
                }
                .select {
                    position: absolute;
                    right: 12px;
                    top: 8px;
                    width: 74px;
                    height: 43px;
                    line-height: 43px;
                    background: #2961EF;
                    border-radius: 30px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
    // 学科分类
    .bacground {
        background: #f7f8fa;
    }
    .type {
        margin: 27px 0 30px 0;
        padding: 14px 17px;
        border-radius: 5px 5px 0px 0px;
        border: 1px solid #e3e8f2;
        .ul {
            font-size: 16px;
    
            font-weight: 300;
            color: #333333;
            display: inline-block;
            vertical-align: text-top;
            width: 7%;
            margin-top: 3px;
        }
        ul {
            display: inline-block;
            vertical-align: text-top;
            // float: right;
            width: 93%;
            li {
                display: inline-block;
                font-size: 16px;
    
                font-weight: 300;
                color: #888888;
                margin-right: 30px;
                line-height: 30px;
            }
        }
        .add {
            margin-top: 15px;
        }
        .addul {
            margin-top: 18px;
        }
    }
    .type:nth-child(1){
      margin-bottom: 0;
    }
    .type:nth-child(2){
      margin-top: 0;
      border-radius: 0 0 5px 5px;
      border-top:none;
      background: #fafafa;
    }
    .brder {
        border-top: none;
        margin: 0 0 21px;
        border-radius: 0px 0px 0px 0px;
        .ul {
            margin-top: 3px;
        }
        .add {
            margin: 0;
        }
    }
    // 推荐课程
    .courselist {
        display: flex;
        flex-wrap: wrap;
        margin-top: 22px;
        .courbox {
            border-radius: 5px 5px 5px 5px;
            border: 1px solid #f1f1f1;
            padding: 10px 10px 0;
            width: 17.5%;
            margin-bottom: 18px;
            position: relative;
            .play {
                position: absolute;
                top: 15px;
                left: 15px;
                background: rgba(41, 97, 239, 0.8);
                border-radius: 5px 5px 5px 5px;
                padding: 3px 10px;
                font-size: 14px;
                color: #ffffff;
                img {
                    margin-right: 5px;
                }
            }
            .hour {
                position: absolute;
                top: 15px;
                right: 15px;
                background: rgba(41, 97, 239, 0.8);
                border-radius: 5px 5px 5px 5px;
                padding: 3px 10px;
                font-size: 14px;
                color: #ffffff;
            }
            img {
            }
            .tit {
                font-size: 14px;
                color: #383838;
                margin-bottom: 25px;
            }
            .bottom {
                height: 40px;
                border-top: 1px solid #f1f1f1;
                img {
                    vertical-align: middle;
                    width: 21px;
                    height: 21px;
                    border-radius: 50%;
                }
                .person {
                    vertical-align: middle;
                    line-height: 41px;
                    padding: 0 15px 0 10px;
                    font-size: 14px;
                    color: #888888;
                    &::after {
                        content: '';
                        border: 1px solid rgba(112, 112, 112, 0.3);
                        height: 2px;
                        margin-left: 10px;
                    }
                }
                .num {
                    vertical-align: middle;
                    line-height: 41px;
                    font-size: 14px;
                    color: #888888;
                }
                .money {
                    vertical-align: middle;
                    line-height: 41px;
                    font-size: 14px;
                    color: #2961EF;
                    float: right;
                }
            }
        }
    }
    // 分页
    .paging {
        width: 534px;
        height: 50px;
        background: rgba(112, 112, 112, 0.18);
        border-radius: 37px 37px 37px 37px;
        margin: 35px auto;
        display: flex;
        align-items: center;
        font-size: 16px;
    
        font-weight: 300;
        color: #888888;
        justify-content: space-around;
        text-align: center;
        div {
            height: 50px;
            line-height: 50px;
            border-right: 1px solid rgba(112, 112, 112, 0.2);
            width: 20%;
            &:nth-child(5) {
                border: none;
            }
        }
    }
    
</style>
